<template>
  <card class="w-100">
    <el-form class="form-horizontal" :model="company" :rules="rules" ref="company" label-width="120px">
      <el-row>
        <el-col :span="24">
          <el-form-item label="업체구분" prop="roleCode">
            <el-select v-model="company.roleCode" disabled="true">
              <el-option
                key="BUILDER"
                value="BUILDER"
                label="시공사"></el-option>
              <el-option
                key="AGENT"
                value="AGENT"
                label="광고대행사"></el-option>
              <el-option
                key="ADVERTISER"
                value="ADVERTISER"
                label="광고주"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="사업자번호" prop="licenseNumber">
            <el-input v-model="company.licenseNumber"></el-input>
          </el-form-item>
          <el-form-item label="회사명" prop="companyName">
            <el-input v-model="company.companyName"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="card-footer text-right">
        <el-button type="primary" v-if="type === 'new'" @click="submitForm('company')">등록</el-button>
        <el-button type="primary" v-if="type === 'edit'" @click="submitForm('company')">수정</el-button>
        <el-button v-if="type === 'new'" @click.prevent="resetForm('company')">리셋</el-button>
        <el-button v-if="type === 'edit'" @click.prevent="historyBack">취소</el-button>
      </div>
    </el-form>
  </card>
</template>

<script>
    import Vue from 'vue'
    import {Select, DatePicker, Form, FormItem, Button, Option, Input, Row, Col, Table, TableColumn} from 'element-ui';
    import CompanyProxy from "@/proxies/CompanyProxy";

    Vue.use(Table);
    Vue.use(TableColumn);

    export default {
        name: "SettingsAccountRegistration",
        components: {
            [DatePicker.name]: DatePicker,
            elSelect: Select,
            elForm: Form,
            elFormItem: FormItem,
            elButton: Button,
            elOption: Option,
            elInput: Input,
            elRow: Row,
            elCol: Col,
        },
        created: function () {
            if(this.$route.params.companySeq !== undefined) {
                this.type = "edit";
                this.company.companySeq = this.$route.params.companySeq;
                this.$store.dispatch('common/setMenuTitle', "업체수정");
                new CompanyProxy()
                    .find(this.company.companySeq)
                    .then((response) => {
                        this.company = response.company;
                    })
            } else {
                this.type = "new";
                this.$store.dispatch('common/setMenuTitle', "업체등록");
            }
        },
        methods: {
            tableRowStyle() {
                return this.$store.state.common.tableHeaderCellStyle;
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if(this.type === "new") {
                            if(confirm("등록하시겠습니까?")) {
                                this.$store.dispatch("settingsCompany/createCompany", this.company);
                            }
                        } else {
                            if(confirm("수정하시겠습니까?")) {
                                this.$store.dispatch("settingsCompany/editCompany", this.company);
                            }
                        }
                    } else {
                        return false;
                    }
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.changeRoleCode("");
            },
            historyBack() {
              history.back();
            },
        },
        data() {
            return {
                type: '',
                readonly: false,
                company: {
                    companySeq: '',
                    companyName: '',
                    roleCode: '',
                    licenseNumber: '',
                },
                rules: {
                    roleCode: [
                        { required: true, message: '업체구분을 선택하세요.', trigger: 'change' }
                    ],
                    licenseNumber: [
                        { required: true, message: '사업자번호를 입력하세요.', trigger: 'blur' }
                    ],
                    companyName: [
                        { required: true, message: '회사명을 입력하세요.', trigger: 'blur' }
                    ],
                }
            }
        },

    }
</script>

<style scoped>

</style>
